import { mulberry32 } from '@physlab/core';

export const DIFFICULTIES = {
  basic: { key: 'basic', label: '基础', level: 1, description: '直接套用公式，关注单位与规范表达' },
  standard: { key: 'standard', label: '进阶', level: 2, description: '两步综合，兼顾公式推导与数值计算' },
  challenge: { key: 'challenge', label: '挑战', level: 3, description: '多过程分析，需要能量与动力学综合判断' },
};

export function difficultyInfo(key) {
  return DIFFICULTIES[key] ?? DIFFICULTIES.standard;
}

export function fmt(value, digits = 2) {
  if (!Number.isFinite(value)) return '—';
  return Number(value.toFixed(digits)).toString();
}

export function fmtUnit(value, unit, digits = 2) {
  const text = fmt(value, digits);
  return unit ? `${text} ${unit}` : text;
}

export function pick(rng, items) {
  return items[Math.floor(rng() * items.length) % items.length];
}

export function shuffle(rng, items) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

/** 按难度筛选并随机抽取模板；模板不够时用剩余模板补齐。 */
export function selectTemplates(rng, templates, count, maxLevel) {
  const preferred = shuffle(rng, templates.filter((item) => item.level <= maxLevel));
  const fallback = shuffle(rng, templates.filter((item) => item.level > maxLevel));
  return [...preferred, ...fallback].slice(0, count);
}

export function createQuestion({
  id,
  type,
  level,
  topic,
  prompt,
  formula,
  answer,
  solution,
  knowledge = [],
  answerValue = null,
  unit = '',
}) {
  return {
    id,
    type,
    level,
    difficulty: level >= 3 ? 'challenge' : level === 2 ? 'standard' : 'basic',
    topic,
    prompt,
    formula,
    answer,
    answerValue,
    unit,
    solution,
    knowledge,
  };
}

export function seededRng(seed) {
  return mulberry32(typeof seed === 'number' ? seed : Date.now() % 2147483647);
}
